import Vue from 'vue'
import {HasError, AlertError, AlertSuccess} from 'vform'

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertSuccess.name, AlertSuccess)

// Load global components dynamically, only require for apo_one
const requireContext = require.context(
  '.', false, /.(OrticTable|OrticChild|OrticCard|OrticButton|OrticTableHeader|OrticPagination|SidebarChildren|OrticActionToolbar|OrticValueSelect|OrticForm|OrticFormGroup|OrticDatepicker|OrticDatepickerControl|OrticInput|OrticInputControl|OrticValueSelectControl|OrticFilter|OrticFilterText|OrticFilterSelect|OrticFilterCheckbox|OrticDelete|OrticValueSelectSearch)\.(vue)$/
)
requireContext.keys().forEach(file => {
  const Component = requireContext(file).default

  if (Component && Component.name) {
    Vue.component(Component.name, Component)
  }
})
